import * as React from "react";
import { t } from "../../i18n/util";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { DialogHeader, FormButtons, HrBotDialog } from "./Primitives";

type Props = {
    label?: React.ReactNode;
    isOpen: boolean;
    onBack: () => void;
    onSubmit: () => void;
    header?: string;
    submitButtonText?: string;
};

export const ConfirmationDialog = ({ label, isOpen, onBack, onSubmit, header, submitButtonText }: Props) => {
    const [open, setOpen] = React.useState(isOpen);
    const isMobile = useMobileMediaQuery();

    // TODO necessary effect? why has this component it's own state?
    React.useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

    const handleClose = () => {
        setOpen(false);
        if (onBack) {
            onBack();
        }
    };

    const handleSubmit = () => {
        setOpen(false);
        onSubmit();
    };

    return (
        <HrBotDialog open={open}>
            <div style={isMobile ? {} : { maxWidth: 450 }}>
                <DialogHeader label={header ?? t("screen.applicantDocuments.delete")} onClose={handleClose} />
                <div style={{ padding: "0 40px", textAlign: "center", wordBreak: "break-word" }}>{label}</div>
                <FormButtons
                    labelBack={t("screen.dataUpload.dialog.cancel")}
                    labelSubmit={submitButtonText ?? t("screen.applicantDocuments.delete")}
                    onBack={handleClose}
                    onSubmit={handleSubmit}
                    style={{
                        justifyContent: "flex-end",
                        marginBottom: 0,
                        padding: 26
                    }}
                />
            </div>
        </HrBotDialog>
    );
};
